<template>
  <span class="data-label">{{ label }}</span>
</template>

<script setup lang="ts">
defineProps<{ label: string }>();
</script>

<style scoped lang="scss">
.data-label {
  color: rgb(var(--v-theme-dark-grey-2));
  font-size: var(--font-size-subtitle-2);
  font-weight: 500;
}
</style>
